import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PictureComponent } from './picture.component';
import { FinderIntersectionModule } from '@finder/shared/directives/intersection/intersection.module';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';

@NgModule({
    imports: [
        CommonModule,
        FinderIntersectionModule,
        SafeHtmlPipeModule,
    ],
    declarations: [
        PictureComponent,
    ],
    providers: [],
    exports: [
        PictureComponent,
    ]
})
export class PictureModule {}
